import { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../services/api";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem("token");
    const userEmail = localStorage.getItem("userEmail");
    const userFullName = localStorage.getItem("userFullName");
    
    if (token && userEmail) {
      setUser({ 
        email: userEmail,
        fullName: userFullName || null
      });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      
      if (response.success) {
        // Store token and user data
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userEmail", response.data.user.email);
        localStorage.setItem("userFullName", response.data.user.fullName);
        localStorage.setItem("isAuthenticated", "true");
        
        setUser(response.data.user);
        return response.data;
      } else {
        throw new Error(response.message || "Login failed");
      }
    } catch (error) {
      throw new Error(error.message || "Invalid credentials");
    }
  };

  const logout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {
      // Continue with logout even if API call fails
      console.log("Logout API error (ignoring):", error.message);
    }
    
    // Clear local storage
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userFullName");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("rememberMe");
    
    setUser(null);
    navigate("/login");
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
